/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_SavedInputs */

const en_statement_taxonomy_editor_saved = /** @type {(inputs: Statement_Taxonomy_Editor_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft saved`)
};

const nl_statement_taxonomy_editor_saved = /** @type {(inputs: Statement_Taxonomy_Editor_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concept opgeslagen`)
};

/**
* | output |
* | --- |
* | "Draft saved" |
*
* @param {Statement_Taxonomy_Editor_SavedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_saved = /** @type {((inputs?: Statement_Taxonomy_Editor_SavedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_SavedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_saved(inputs)
	return en_statement_taxonomy_editor_saved(inputs)
});